import workspaceQuery from 'graphql/queries/purchases/PurchaseOrderLineAuditByFieldWorkspaceQuery.graphql';
import fragment from 'graphql/fragments/common/AuditByFieldFragment.graphql';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';

const PurchaseOrderLineAuditByField = {
  type: 'AuditChange',
  formTitle: 'Purchase Order Line Audit',
  formUrl: '/Purchasing/PurchaseOrderLineAudit/Form/',
  workspace: workspaceQuery,
  fragment,
  workspaceUrl: '/menu/Purchase',
  screenReference: 'PURCHASING', //There's no direct approach to this screen (You get there via lines/right-click), so just link to purchasing as permission.
  operations: ALLOW_VIEW,
};

export default PurchaseOrderLineAuditByField;
